export default __webpack_public_path__ + "static/media/long.3f60d560.svg";